module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium.10fcd8d.woff2";